import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../../common/dropdown'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'
import { formatVal } from '../../../../helpers/value'
import classes from '../index.module.scss'

export const SearchFilterListCheckbox = ({
  data,
  title,
  options,
  checked,
  isI18n,
  onChange,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const onCheckboxChange = (item, value) => {
    onChange({ [item.key]: value })
  }

  return (
    <div>
      <Element
        elementName="div"
        style={{ color: '#2B457D' }}
        className={[
          'dFlex justifyContentBetween alignItemsCenter textUppercase fw600',
          classes.checkboxItem,
        ].join(' ')}
      >
        <Translate value={title} />
      </Element>

      {options.map((item, index) => (
        <Element
          key={index}
          elementName="div"
          className={[
            'dFlex justifyContentBetween alignItemsCenter',
            classes.checkboxItem,
          ].join(' ')}
        >
          <div className="dFlex alignItemsCenter">
            <Checkbox
              title={item.name}
              value={item.value}
              checked={checked[item.key]}
              isCheckOnClickText
              isI18n={isI18n}
              onChange={(value) => onCheckboxChange(item, value)}
            />
            {item.isShowInfo && (
              <div style={{ marginLeft: 4 }}>
                <Tooltip
                  position={positionDropdown.RIGHT_CENTER}
                  tooltipContent={item.tooltipInfo}
                  isI18n
                >
                  <Icon
                    className="icon-info-circle"
                    style={{ fontSize: 16, color: '#9c9c9c' }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
          <Element
            elementName="span"
            style={{ color: '#9C9C9C' }}
            className="ml1"
          >
            {formatVal(data[item.key] || 0, locale, false, 0)}
          </Element>
        </Element>
      ))}
    </div>
  )
}

SearchFilterListCheckbox.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  checked: PropTypes.object.isRequired,
  isI18n: PropTypes.bool,
  onChange: PropTypes.func,
}

SearchFilterListCheckbox.defaultProps = {
  data: {},
  title: '',
  options: [],
  checked: {},
  isI18n: false,
  onChange: () => {},
}
